export async function loginChatbotWithSpa(apiHttpUrl, apiKey, recaptchaToken) {
  const response = await fetch(`${apiHttpUrl}/v1/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
    },
    body: JSON.stringify({
      recaptcha_token: recaptchaToken,
    }),
  });

  if (!response.ok) {
    throw new Error(`Chatbot login failed: ${response.status}`);
  }

  return response.json();
}
